import React, { useEffect, useState } from "react";
import ReactBarcode from "react-barcode";
import styled from "styled-components";
import { breakpoints } from "../../utils/styles";

const Container = styled.div`
    & > svg {
        display: block;
        margin: 0 auto;
        max-width: 90%;
    }
`;

const CouponCode = styled.p<{copied:boolean}>`
    font-family: 'Roboto Mono', monospace;
    font-size: 1.25rem;
    letter-spacing: 0.4em;
    margin-bottom: 0 !important;
    padding: 0;
    position: relative;
    text-align: center;
    transition: opacity 0.5s ease-in-out;

    ${props => props.copied && 'opacity: 0; transition: none;'}

    @media screen and (min-width: ${breakpoints.desktop}px) {
        font-size: 1rem;
    }

    body.theme-market &,
    body.theme-platinum & { margin-top: 1rem; }
`;

const CopyButton = styled.i`
    cursor: pointer;
    margin-left: 1em;
`;

type BarcodeProps = {
    copy?: boolean;
    height?: number;
    value: string;
    width?: number;
};

const Barcode: React.FC<BarcodeProps> = ({
    copy = true,
    height = 40,
    value,
    width = 3,
}) => {
    return <Container>
        <ReactBarcode value={value} width={width} height={height} displayValue={false} />
        <Code code={value} copy={copy} />
    </Container>;
};

function Code({code, copy}: {code: string, copy?: boolean}) {
    const [copied, setCopied] = useState<boolean>(false);
    useEffect(() => {}, [copied]);

    function copyToClipboard() {
        navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(function() {
            setCopied(false);
        }, 10);
    }

    return <CouponCode copied={copied}>
        {code}
        {copy && <CopyButton className="fa-regular fa-copy" onClick={copyToClipboard}></CopyButton>}
    </CouponCode>;
}

export default Barcode;
